import React, 
       { useContext,
         useEffect,
         useState } from 'react';
import { Redirect,
         //useNavigate,
         useHistory,
         withRouter } from 'react-router-dom';

import { Container,
         TextField,
         Fab,
         IconButton,
         Grid,
         Fade,
         CircularProgress,
         Link,
         Button, 
         Typography} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGoogle, 
         faYahoo,
         faFacebookF } from '@fortawesome/free-brands-svg-icons';  //icons: https://fontawesome.com/icons
import { faBomb,
         faUserPlus,
         faMask,
         faEyeSlash,
         faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { GATag, Stack } from "../util/tools";
import { process_temp_anon_login,
         process_user_invite } from "../util/util";
import { INFO, CONSTS } from "../util/object";
import { appContext } from "./index";
//import { firebaseAuth } from "../util/constants";
import firebase from 'firebase/app';
import { AuthClass,
         checkAuthResponse } from '../class/AuthClass';

var auth = new AuthClass();
const invite_useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '80vh',
        minHeight: '80vh',
        alignSelf: 'center',
        //justifyContent: 'flex-start',
        //overflow: 'auto',    // enable scroll
        //backgroundColor:'#eeeeee',
    },
    spacer: {
        height: '0vh',
        //backgroundColor:'#ff00dd',
    },
    icon_tray: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        padding: '0',
        color: '#4d4b70',
        marginTop: '20px',
        //backgroundColor:'#dddddd',
    },
    icon: {
        marginLeft: '2.5vh',
        marginRight: '2.5vh',
        minWidth: '7vh',
        minHeight: '7vh',
        justifyContent: 'flex-start',
        //backgroundColor:'#dddd88',
    },
    box_icon: {
        borderColor: 'rgba(255,255,255,0)',
        borderRadius: '15px',
        border: '0px',
        boxShadow: '0 10 20 0',
        paddingLeft: '0',
        paddingRight: '0',
        margin: '0.6vh auto 1.2vh auto',
        width: '30vw',
        //minWidth: '280px',
        minWidth: '230px',
        height: '7vh',
        minHeight: '60px',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        //minWidth: '200px',
        backgroundColor: 'rgba(43, 65, 120, 0.95)',     // Dark Cornflower Blue
    },
    anon_box_icon: {
        backgroundColor:'#737e96',
        display: "none",
    },
    logo_icon: {
        //marginRight: '2vw',
        //width: "15%",       // 20%
        //minWidth: '5vw',   // 10vw
        //minHeight: '3vh',
        width: "50%",
        alignSelf: "flex-start",
        //backgroundColor:'#dddd88',
    },


    logo_text: {
        marginLeft: '0.9vh',
        fontSize: '1.1rem',     // 1.5
        textAlign: 'start',
    },

    warning_text: {
        marginLeft: '1vh',
        fontSize: '1.1rem',     // 1.5
        textAlign: 'center',
    },

    bullet_list: {
        margin: '20px 0 20px 15px',
        textAlign: 'start',
        paddingRight: '0',
    },

    item_text: {
        margin: "0 0 10px 0.5vh",
        fontSize: '0.9rem',     // 1.5
        textAlign: 'start',
        padding: '0',
        color: '#4d4b70',
    },


    grid_row: {
        alignContent: "center",
    },
    grid_text: {
        //alignSelf: "flex-start",
        alignSelf: "center",
    },

    link1: {
        textDecoration: "underline",
        alignSelf: "center",
        marginLeft: "6px",
        verticalAlign: "center",
        //backgroundColor:'#ff88ff',
    },

    link: {
        marginTop: '4vh',
        textDecoration: "underline",
        //backgroundColor:'#ff88ff',
    },

    progress: {
        marginTop: '2vh',
        marginBottom: '2vh',
        alignSelf: 'center',
        //backgroundColor:'#ff88ff',
    },
    hidden: {
        display: "none",
    }
}))


const Invite = (props) => {
    var has_login;
    var timeout;
    //var navigate = useNavigate();
    var history = useHistory();
    const classes = invite_useStyles();
    const [ Invite, setInvite ] = useState({email: '', password: '', show: false, loginMessage: ''})
    const [ ShowPassword, setShowPassword ] = useState(false);
    const [ HasInvite, setHasInvite ] = useState(false);
    const [ ValidInvite, setValidInvite ] = useState(false);
    const [ Timeout, setTimeOut ] = useState(null);

    const { State, Dispatch } = useContext(appContext);
    function setState(name, value) {
        //console.log("setState.login:  ",name," =", value, " @", Stack(new Error().stack));
        Dispatch({ type: [name], value: value });  // reducer wrapper
    }
    

    useEffect(() => {
        //setState('show_login', false);    // do no show email login by default
        //checkAuthResponse(State, setState, "invite");

        setState("show_progress", false);   // need this?
        INFO.show_login_progress = false;

        if (auth.loggedIn() == true) {
            var cookie_uid = auth.getCookie(CONSTS.COOKIE_FB_UID); 
            var cookie_email = auth.getCookie(CONSTS.COOKIE_EMAIL); 

            setState("show_progress", true);
            setState('authed', true);
            setState('has_login',  auth.getCookie(CONSTS.COOKIE_HAS_LOGIN)); 
            setState('uid', cookie_uid);      // use logged in id for firestore
            setState('email', cookie_email);
            setState('photo', auth.getCookie(CONSTS.COOKIE_AVATAR));      // use logged in id for firestore
            //setState('has_login', localStorage.getItem('has_login'));
            //setState('email', auth.getEmail());      // use logged in id for firestore
            //setState('photo', auth.getAvatar());      // use logged in id for firestore

            INFO.show_invite_progress = true;
            INFO.uid = cookie_uid;      // use logged in id for firestore
            INFO.login_uid = cookie_uid;      // remember a copy
            INFO.email = cookie_email;      // use logged in id for firestore

            //auth.setLoginCount(auth.getLoginCount() + 1);
            auth.setCookie(CONSTS.COOKIE_LOGIN_COUNT, auth.getCookie(CONSTS.COOKIE_LOGIN_COUNT) + 1);
            console.log("auth.197:  USER ALREADY LOGIN");
        } else {
            INFO.show_invite_progress = false;
            setState("show_progress", false);
        }
    }, [1]);

     
    useEffect(() => {
        //setState("show_progress", false);
        //console.log("useEffect: State.show_welcome changed! "+State.show_welcome);
        //setState('show_welcome', false);
    //}, [State.show_welcome, State.registration, State.refresh_display, State.splash_done]);
    }, [State.refresh_display, State.splash_done, State.show_progress]);
    

    useEffect(() => {
        if(HasInvite === false) {
            console.log("check_invite.266:  START INVITE FLOW ", INFO.invite_key);
            if(INFO.invite_key === null) {
                setHasInvite(false);
            } else {
                setHasInvite(true);
                if (INFO.invite_key !== "_invalid_") {
                    setValidInvite(true);
                }
            }
        }
    }, [INFO.invite_key]);

    // process input event and write into local State.object
    const inputInvite = name => event => {
        setState([name], event.target.value)
    }

    /*
    // function call to merge into local State.object
    function setInviteState (name, value) {
        console.log("setInviteState: name="+name+"  value="+value);
        setInvite(prev=>({ ...prev.Invite_State, [name]: value}));
    }
    */

    function showInvite() {
        if (State.show_login)
            setState('show_login', false);
        else
            setState('show_login', true);
    }



    const handleRegister = e => {
        e.preventDefault();

        console.log("****** handleRegister: "+State.login+" "+State.password)
        auth.firebase_auth(State.login, State.password)
        .then(() => {
            setState('authed', true);
            setState("show_progress", false);
        })
        .catch(error => {
            console.log("handleRegister: error ", error)
            setState('loginMessage', error.message);
            setState('show_login', true);
        });
    };


    // Same flow as youtube_drill, creates a temp user acct, return fake_fb_uid store in cookie
    // OLD: use fixed email to fake anon loging, force timeout after one session
    //
    const handleAnonymousDemo = e => {
        console.log("****** handleAnonInvite: auth=", auth, " State=", State);
        INFO.invite_key = "_demo_mode_";

        var login_promise = process_temp_anon_login(State, setState);
        Promise.all([ login_promise ])
        .then((res) => {
            console.log("invite.195:      res from process_temp_anon_login() =", res);
            process_user_invite("anon_demo.279");
        })

        /*  OLD
        auth.anonLogin(State, setState);      // login as anon user
        checkAuthResponse(State, setState, "invite.310");
        */
    }


    // player fill out form to request invite
    //
    const handlePlayerRequest = () => {
        props.Register();
    }


    const handleFB = () => {
        //navigate('https://www.facebook.com/axosai');
        //history.push('https://www.facebook.com/axosai');
        var web = "https://m.facebook.com/groups/189714002982372/?ref=pages_profile_groups_tab&paipv=1"
        var mobile = "https://www.facebook.com/groups/189714002982372/"

        window.location.href =  mobile;
    }


    const handleRegistration = e => {
        console.log("reg.359:   START REGISTRATION PROCESS   invite_key=", INFO.inviet_key);
        INFO.show_invite = false;
        props.Register();
    }

    const handleLogin = e => {
        console.log("reg.320:   START LOGIN PROCESS   invite_key=", INFO.inviet_key);
        INFO.show_invite = false;
        //checkAuthResponse(State, setState, "existing_acct");

        props.Login();
    }


    return (
        <div id="quickstart-sign-in" className={classes.root}>

            <React.Fragment>
            <div className={classes.spacer} />
             <div className={classes.progress}>

                <Fade   in={(State.show_progress || INFO.show_invite_progress)}
                        style={{ transitionDelay: (State.show_progress || INFO.show_invite_progress) ? '30ms' : '0ms', }}
                        unmountOnExit >
                    <CircularProgress />
                </Fade>
            </div>
            <Container className={classes.icon_tray} >

                {(ValidInvite === false) ?
                    <React.Fragment>
                    {(HasInvite === false) ?
                        <React.Fragment>
                            <Typography className={classes.warning_text}>
                                CURRENTLY BY INVITATION-ONLY
                            </Typography>
                            {false && <Container className={classes.bullet_list}>
                                <Container className={classes.item_text}> 
                                    - PLAYER INVITE - Fill Out
                                    <Link component="button"
                                        className={classes.link1}
                                        onClick={handlePlayerRequest}>
                                        {"Request"}
                                    </Link>
                                </Container>
                                <Container className={classes.item_text}>
                                    - COACH INVITE - Join 
                                    <Link component="button"
                                        className={classes.link1}
                                        onClick={handleFB}>
                                        {"Facebook Coach Group"}
                                    </Link>
                                </Container>
                            </Container>}
                        </React.Fragment>

                    :

                        <React.Fragment>
                            <Typography className={classes.warning_text}>
                                INVALID  INVITE LINK
                            </Typography>

                            <Typography style={{marginBottom: "6vh"}} className={classes.warning_text}>
                                PLEASE VERIFY WITH THE SENDER.
                            </Typography>
                        </React.Fragment>
                    }
                    </React.Fragment>

                :
                    <React.Fragment>
                        <Typography style={{marginBottom: "6vh"}} className={classes.warning_text}>
                            INVITE LINK VERIFIED
                        </Typography>
                    
                        <Button color="primary" 
                                variant="contained" 
                                onClick={handleRegistration}
                                aria-label="register" 
                                className={classes.fab+" "+classes.box_icon+" "+classes.box_icon} >
                            <Grid container className={classes.grid_row}>
                                <Grid item xs={3}>
                                <FontAwesomeIcon 
                                        className={classes.logo_icon}
                                        icon={faUserPlus} 
                                        style={{width: '50%'}}
                                        size="3x" />
                                </Grid>
                                <Grid item xs={9} className={classes.grid_text}>
                                    <Typography className={classes.logo_text}>
                                        REGISTER
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Button>
                    </React.Fragment>
                }

            </Container >

            <Button color="primary" 
                    variant="contained" 
                    onClick={handleAnonymousDemo}
                    aria-label="Anonymous" 
                    className={classes.fab+" "+classes.box_icon+" "+classes.box_icon} >
                <Grid container className={classes.grid_row}>
                    <Grid item xs={3}>
                    <FontAwesomeIcon 
                            className={classes.logo_icon}
                            icon={faMask} 
                            style={{width: '50%'}}
                            size="3x" />
                    </Grid>
                    <Grid item xs={9} className={classes.grid_text}>
                        <Typography className={classes.logo_text}>
                            DEMO MODE
                        </Typography>
                    </Grid>
                </Grid>
            </Button>

            <Link component="button"
                className={classes.link}
                variant="body2"
                value={false}
                onClick={handleLogin}>
                {"I HAVE AN ACCOUNT"}
            </Link>


            {/*<Button size="large"                              
            onClick={showInvite} 
                    className={classes.button}
                    color="primary">
                OR USE EMAIL TO {(State.has_login) ? "SIGN IN" : "REGISTER"}
            </Button>*/}

            </React.Fragment>

        </div>
    );
}



export default withRouter(Invite);